module.exports = __webpack_public_path__ + "img/CRED.62a68f39.svg";